import type { Campaign, CharacterSummary } from '@rollcall/contracts'
import type { Api } from '../api.js'
import { CampaignListScreen } from './campaigns.js'
import { CharacterList } from './characters.js'
import { useT } from './i18n-context.js'

/**
 * Главная аккаунта (D8).
 *
 * Один и тот же человек бывает и мастером, и игроком — это нормально
 * и менять этого не надо. Менять надо было то, что после входа он
 * попадал в один из двух разделов и застревал в нём: чтобы попасть
 * во второй, приходилось выйти и войти заново.
 *
 * Поэтому здесь оба раздела рядом, и оба — те самые экраны, а не их
 * сокращённые копии. Копия списка разошлась бы с оригиналом на первой
 * же правке: драфт, помеченный на одном экране, на другом остался бы
 * обычным персонажем.
 *
 * Гостю эта страница не показывается: аккаунта у него нет, и путь
 * по ссылке-приглашению остаётся прежним (D8, D29).
 */
export function HomeScreen({
  api,
  onCreateCharacter,
  onOpenCharacter,
  onOpenCampaign,
}: {
  readonly api: Api
  readonly onCreateCharacter: () => void
  readonly onOpenCharacter: (character: CharacterSummary) => void
  readonly onOpenCampaign: (campaign: Campaign) => void
}) {
  const t = useT()

  return (
    <div className="app-home" aria-label={t('home.title')}>
      {/* Персонажи первыми: за столом человек чаще игрок, чем мастер,
          и своих персонажей у него больше, чем своих кампаний. */}
      <CharacterList
        api={api}
        campaignId={null}
        onCreate={onCreateCharacter}
        onOpen={onOpenCharacter}
      />
      {/* Кнопки «Свои записи» здесь больше нет: она стояла под двумя
          списками, то есть ниже всего, что на этой странице есть,
          и найти её можно было только прокруткой до конца. Тот же
          вход теперь в меню шапки — он виден с любого экрана,
          включая этот, — и у флага, который подключает записи
          к столу (D53). */}
      <CampaignListScreen api={api} onOpen={onOpenCampaign} />
    </div>
  )
}
